const initialState = {
	isLoading: false
}

export default function user(state = initialState, action) {

	let newState = Object.assign({}, state)

	switch(action.type) {
		case 'START_LOADING':

			newState.isLoading = true
			
			break;

		case 'STOP_LOADING':
		
			newState.isLoading = false
			
			break;

		default:
			return state
	}

	return newState
}


// WEBPACK FOOTER //
// ./src/reducers/loader.reducer.js